import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const updateQuestionAnswerAction = createAsyncThunk(
    'update-question-answer',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/admins/api/update-question-answer`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const updateQuestionAnswerSlice = createSlice({
    name: 'update-question-answer',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(updateQuestionAnswerAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(updateQuestionAnswerAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(updateQuestionAnswerAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const updateQuestionAnswerReducer = updateQuestionAnswerSlice.reducer